import Navbar from "Components/layout/container/Navbar.js";
import AddPin from "Components/layout/container/AddPin";
import Map from "Components/layout/container/map/Map";
import PinDialog from "Components/layout/container/PinDialog";
import 'Style/map.css';
import 'Style/home.css';
import 'Style/staticPin.css';
import { useSelector } from "react-redux";
import { useState, useRef } from "react";
import FeedbackPopup from "Components/layout/container/FeedbackPopup";
import { LOADING_TEXT } from "Strings";
import { useFirestoreConnect, isLoaded } from "react-redux-firebase";
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { updatedGeneralPinDialog } from "State/generalPinDialogSlice";
import PlaceablePin from "Components/layout/container/map/PlaceablePin";
import { updateGeneralPlaceablePin } from 'State/generalPlaceablePinSlice';

const today = new Date().toISOString();

function HomeView(props) {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const mapRef = useRef();

    const [isPopupDisplayed, setPopupDisplayed] = useState(props.popup);

    useFirestoreConnect([
        {
            collection: "Pins",
            where: [
                ["is_private", "==", false],
                ["visible_from", "<", today]
            ],
            storeAs: "projectPins"
        },
        {
            collection: "Pins",
            where: [
                ["project_id", "==", null]
            ],
            storeAs: "generalPins"
        }
    ])

    const projectPins = useSelector((state) => state.firestore.ordered["projectPins"]);
    const generalPins = useSelector((state) => state.firestore.ordered["generalPins"]);
    const selectedPinId = useSelector((state) => state.generalPinDialog.pinId);

    if (!isLoaded(projectPins) || !isLoaded(generalPins)) { 
        return <div>{LOADING_TEXT}</div> 
    }

    const pins = projectPins.concat(generalPins);

    if (!pins) return <div>{LOADING_TEXT}</div>;

    function handlePopupChange() {
        navigate('/', { state: { popup: false } });
    };

    const handleOnClickPin = (pinId) => {
        dispatch(updatedGeneralPinDialog({
            pinId: pinId
        }))
    }

    return (
        <div id="homePage">
            <Navbar/>
            <Map ref={mapRef}
                 staticPins={pins} onStaticPinClick={handleOnClickPin}
                 placeablePin={PlaceablePin} handleUpdatePin={updateGeneralPlaceablePin} />
            <FeedbackPopup trigger={location.state?.popup} setTrigger={handlePopupChange} />
            {selectedPinId && 
                <PinDialog
                    pinIdListener={(state) => state.generalPinDialog.pinId}
                    updatePinDialog={updatedGeneralPinDialog}
                />
            }
            <AddPin mapRef={mapRef} />
            <FeedbackPopup trigger={isPopupDisplayed} setTrigger={setPopupDisplayed} />
        </div>
    )
}


export default HomeView;